import { render, staticRenderFns } from "./prizeCenter2.vue?vue&type=template&id=0f2f9a19&scoped=true"
import script from "./prizeCenter2.vue?vue&type=script&lang=js"
export * from "./prizeCenter2.vue?vue&type=script&lang=js"
import style0 from "./prizeCenter2.vue?vue&type=style&index=0&id=0f2f9a19&prod&scoped=true&lang=scss"
import style1 from "./prizeCenter2.vue?vue&type=style&index=1&id=0f2f9a19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f9a19",
  null
  
)

export default component.exports